import { render, staticRenderFns } from "./DeliveryLog.vue?vue&type=template&id=3264e558&scoped=true&"
import script from "./DeliveryLog.vue?vue&type=script&lang=js&"
export * from "./DeliveryLog.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryLog.vue?vue&type=style&index=0&id=3264e558&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3264e558",
  null
  
)

export default component.exports